/* eslint-disable import/prefer-default-export */

export const isEmbeddedSelector = (state) => state?.common?.isEmbedded || false;
export const goToEmbeddedSelector = (state) => state?.common?.goToEmbedded || false;
